import React, {useState, useEffect} from 'react'
import {useSelector} from "react-redux";
import {getGptAnalysis} from "../api/client";
import {CenteredSpinner} from "./CenteredSpinner";

const Choice = (props) => {

    let text = props.text.trim() + (props.finish_reason === "stop" ? "" : "...");
    return <div style={{whiteSpace: "pre-wrap"}}>{text}</div>
}

const ChoiceList = (props) => {
    return <div>
        {props.choices.filter(a=>a.text != null && a.text.length > 0).map(a=><div>
            <Choice isPre={props.isPre} {...a} />
        </div>)}
    </div>
}

const Cost = (props) => {
    return <span>${((props.tokens / 1000) * props.cost).toFixed(4)} for {props.tokens.toLocaleString()} tokens</span>
}

const TotalCost = (props) => {
    
    let totalTokens = props.actionItems.usage.total_tokens +
        props.keySentences.usage.total_tokens +
        props.summary.usage.total_tokens +
        props.tooLongDidNotRead.usage.total_tokens +
        props.topics.usage.total_tokens;
    return <Cost cost={props.cost} tokens={totalTokens} />
}

const Response = (props) => {
    return <div>
        <small className="text-success">Processing this meeting cost: <TotalCost cost={props.cost} {...props} /></small>
        <hr/>
        <div className="sub-header">Action Items</div>
        <ChoiceList choices={props.actionItems.choices} />
        <hr/>
        <div className="sub-header">Key Sentences</div>
        <ChoiceList choices={props.keySentences.choices} />
        <hr/>
        <div className="sub-header">Summary</div>
        <ChoiceList choices={props.summary.choices} />
        <hr/>
        <div className="sub-header">tl;dr</div>
        <ChoiceList choices={props.tooLongDidNotRead.choices} />
        <hr/>
        <div className="sub-header">Topics</div>
        <ChoiceList choices={props.topics.choices} />
        <hr/>
        <div className="sub-header">Sentences Used</div>
        <div style={{whiteSpace: "pre-wrap"}}>{props.chunk}</div>
    </div>
}

export const GptTab = () => {
    
    const [adaAnalysis, setAdaAnalysis] = useState(null);
    const [babbageAnalysis, setBabbageAnalysis] = useState(null);
    const [curieAnalysis, setCurieAnalysis] = useState(null);
    const [davinciAnalysis, setDavinciAnalysis] = useState(null);
    
    const selectedMeetingId = useSelector(state => state.users.selectedMeetingId);

    const loadGptAnalysis = async () => {
        setAdaAnalysis(null);
        setBabbageAnalysis(null);
        setCurieAnalysis(null);
        setDavinciAnalysis(null);
        setAdaAnalysis(await getGptAnalysis(selectedMeetingId, "text-ada-001"));
        setBabbageAnalysis(await getGptAnalysis(selectedMeetingId, "text-babbage-001"));
        setCurieAnalysis(await getGptAnalysis(selectedMeetingId, "text-curie-001"));
        setDavinciAnalysis(await getGptAnalysis(selectedMeetingId, "text-davinci-003"));
    }
    
    useEffect(() => {
        if(selectedMeetingId != null) {
            loadGptAnalysis();
        }
    }, [selectedMeetingId]);

    if(selectedMeetingId == null)
        return <div>No meeting selected.</div>
    
    return <div style={{display: "flex", gap: "24px"}}>
        <div style={{width: "25%"}}>
            <div className="header">Ada</div>
            <div className="meetingPanel" style={{height: "70vh", overflow: "auto"}}>
                {adaAnalysis == null ? <CenteredSpinner message="Loading..." height="65vh" /> : adaAnalysis?.responses.map(a => <Response cost={0.0004} {...a} />)}
            </div>
        </div>
        <div style={{width: "25%"}}>
            <div className="header">Babbage</div>
            <div className="meetingPanel" style={{height: "70vh", overflow: "auto"}}>
                {babbageAnalysis == null ? <CenteredSpinner message="Loading..." height="65vh" /> : babbageAnalysis?.responses.map(a => <Response cost={0.0005} {...a} />)}
            </div>
        </div>
        <div style={{width: "25%"}}>
            <div className="header">Curie</div>
            <div className="meetingPanel" style={{height: "70vh", overflow: "auto"}}>
                {curieAnalysis == null ? <CenteredSpinner message="Loading..." height="65vh" /> : curieAnalysis?.responses.map(a => <Response cost={0.0020} {...a} />)}
            </div>
        </div>
        <div style={{width: "25%"}}>
            <div className="header">Davinci</div>
            <div className="meetingPanel" style={{height: "70vh", overflow: "auto"}}>
                {davinciAnalysis == null ? <CenteredSpinner message="Loading..." height="65vh" /> : davinciAnalysis?.responses.map(a => <Response cost={0.0200} {...a} />)}
            </div>
        </div>
    </div>

};